import useInView from "../hooks/useInView";

/**
 * FadeIn
 * Wraps children in a div that fades + slides up when scrolled into view.
 * @param {React.ReactNode} children
 * @param {number} delay - animation delay in seconds
 * @param {object} style - additional inline styles
 */
const FadeIn = ({ children, delay = 0, style = {} }) => {
  const [ref, visible] = useInView();

  return (
    <div
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default FadeIn;